import {createContext, useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types'

import Container from '../lib/Container'

export const OrganizationCobrandingContext = createContext(null)

const getConfigStore = () => Container.getStore('config')

const normalizeOrganizationCobranding = organizationCobranding => {
  if (!organizationCobranding) return null

  return {
    enabled: organizationCobranding.enabled,
    organizationId: organizationCobranding.organization_id,
    organizationLogoUrl: organizationCobranding.organization_logo_url,
    primaryColor: organizationCobranding.primary_color,
    secondaryColor: organizationCobranding.secondary_color,
    tertiaryColor: organizationCobranding.tertiary_color,
    type: organizationCobranding.type,
  }
}

const getOrganizationCobranding = () => {
  const configStore = getConfigStore()
  const configData = configStore?.getState().data
  const cobranding = configData?.cobranding

  if (cobranding?.type !== 'organization') return null

  return normalizeOrganizationCobranding(cobranding)
}

export const OrganizationCobrandingProvider = ({children}) => {
  const [
    organizationCobranding,
    setOrganizationCobranding
  ] = useState(getOrganizationCobranding)
  
  const configStore = getConfigStore()

  useEffect(() => {
    if (!configStore) return undefined

    const updateOrganizationCobranding = () => {
      setOrganizationCobranding(getOrganizationCobranding())
    }

    configStore.addChangeListener(updateOrganizationCobranding)
    updateOrganizationCobranding()

    return () => {
      configStore.removeChangeListener(updateOrganizationCobranding)
    }
  }, [configStore])

  return (
    <OrganizationCobrandingContext.Provider value={organizationCobranding}>
      {children}
    </OrganizationCobrandingContext.Provider>
  )
}

OrganizationCobrandingProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export const useOrganizationCobranding = () => {
  return useContext(OrganizationCobrandingContext)
}
